const WebSecurity = () => {
  return (
    <div className="relative flex items-center mt-[200px] mb-20 lg:py-0" id="roadmap">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-10 lg:gap-0">
          {/* Left side text content */}
          <div className="w-full lg:w-1/2 flex justify-center items-center relative">
            <div className="relative w-[280px] h-[280px] sm:w-[350px] sm:h-[350px] lg:w-[400px] lg:h-[400px]">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-contain bg-black"
                poster="/static/videos/web3.mp4"
              >
                <source src="/static/videos/web3.mp4" type="video/mp4" />
              </video>
            </div>

          </div>
          <div className="w-full lg:w-1/2 text-white text-center lg:text-left">
            <div className="">
              <h1 className=" uppercase leading-tight tracking-wide">
                <div className="text-3xl sm:text-4xl lg:text-5xl font-bold animate-slide-in opacity-0" style={{ animationDelay: '0.3s', animationFillMode: 'forwards' }}>
                  Web3 security </div>
                <span className="text-3xl sm:text-4xl lg:text-5xl font-light">is broken</span>
              </h1>
              <div className="text-base flex flex-col sm:text-lg mt-8">
                <span className="text-white font-sans leading-snug tracking-wide mt-10">High-cost audits, centralized control, and slow verification processes leave developers exposed to exploits, rug pulls, and vulnerabilities. Ciphegis changes that.</span>
                <span className="mt-4">
                  We are building a decentralized security audit marketplace, where blockchain projects connect with top-tier security experts to fortify smart contracts—efficiently, transparently, and without gatekeepers.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default WebSecurity;